import { render, staticRenderFns } from "./ClosedDeal.vue?vue&type=template&id=2263465b&scoped=true"
import script from "./ClosedDeal.vue?vue&type=script&lang=js"
export * from "./ClosedDeal.vue?vue&type=script&lang=js"
import style0 from "./ClosedDeal.vue?vue&type=style&index=0&id=2263465b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2263465b",
  null
  
)

export default component.exports